import { Badge } from "@mantine/core"
import classes from "./status-badges.module.css"

type CatalogEntry = {
  code: string
  name?: string
  sentName?: string | null
  color?: string | null
}

type Props = {
  code: string | null | undefined
  catalog: ReadonlyArray<CatalogEntry>
  /** Which catalog field to use as the label. Defaults to "name". */
  labelField?: "name" | "sentName"
  fallback?: string
}

export function StatusBadge({ code, catalog, labelField = "name", fallback = "-" }: Props) {
  const entry = catalog.find((c) => c.code === code)
  const color = entry?.color ?? undefined
  const label = (labelField === "sentName" ? entry?.sentName : entry?.name) ?? fallback
  const cssVars = color ? ({ "--status-color": color } as React.CSSProperties) : undefined
  return (
    <Badge
      size="md"
      radius="sm"
      variant="outline"
      classNames={{ root: classes.root }}
      style={cssVars}
      styles={{ label: { overflow: "visible" } }}
    >
      {label}
    </Badge>
  )
}
